import * as React from "react";
const SvgFiRrSeal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-seal_svg__a)">
      <path
        fill="#062147"
        d="M23.158 9.879 21 7.72V6c0-1.654-1.346-3-3-3h-1.72L14.121.843C12.988-.29 11.012-.29 9.88.843L7.721 3h-1.72C4.345 3 3 4.346 3 6v1.72L.841 9.88a3.006 3.006 0 0 0 0 4.242L3 16.279v1.72c0 1.655 1.346 3 3 3h1.721l2.157 2.158c.567.566 1.32.879 2.122.879s1.555-.312 2.121-.88L16.28 21H18c1.654 0 3-1.346 3-3v-1.721l2.158-2.158a3.006 3.006 0 0 0 0-4.242m-1.415 2.828-2.45 2.45a1 1 0 0 0-.294.708V18c0 .552-.449 1-1 1h-2.135a1 1 0 0 0-.707.293l-2.45 2.45a1.02 1.02 0 0 1-1.415 0l-2.45-2.45A1 1 0 0 0 8.133 19H6c-.55 0-1-.448-1-1v-2.135a1 1 0 0 0-.293-.707l-2.45-2.451a1 1 0 0 1 0-1.414l2.451-2.451A1 1 0 0 0 5 8.135V6c0-.552.45-1 1-1h2.135c.265 0 .52-.105.707-.293l2.451-2.45a1.02 1.02 0 0 1 1.414 0l2.451 2.45a1 1 0 0 0 .707.293H18c.551 0 1 .448 1 1v2.135c0 .266.105.52.293.707l2.45 2.45a1 1 0 0 1 0 1.415"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-seal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSeal;
